import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import LanguageSelect from "components/ProjectNonSpecificComponents/Elements/LanguageSelect"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { observer } from "mobx-react"
import React, {  } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"
import Logo from "../../../Global/atoms/Logo"
import UserSideActiveConfigNavigation from "components/ProjectSpecificComponents/Elements/Tables/organisms/UserSideActiveConfigNavigation"
import GoAdminButton from "../../atoms/Buttons/GoAdminButton"
import { UserInfo } from "../UserInfo"

interface Props {}

const NavBarUserDesktop = observer(({}: Props) => {
	const store = useStore()
	const formStore = useFormStore()
	const { t } = useTranslation()
	const location = useLocation()
	
	return (
		<div className="flex flex-col w-screen fill-cter relative">
			<HyperDiv
				direction="row"
				className="fill-cter relative"
				style={{
					height: formStore.settingsData.personalize.bigLogo ? 140 : 60,
					padding: "0 1.5rem",
					backgroundColor: formStore.settingsData.personalize.colorHeader,
					overflow: "hidden",
					boxShadow: "0px 0px 2px 4px #e0e0e0",
				}}
				spacedBetween
				centeredY
			>
				<div style={{ minWidth: "33%" }}>
					{!formStore.settingsData.personalize.bigLogo && <Logo />}
				</div>
				<div>{formStore.settingsData.personalize.bigLogo && <Logo />}</div>

				<HyperDiv
					direction="row"
					centeredY
					alignedRight
					spaceBetweenElems="1rem"
					style={{ minWidth: "33%" }}
				>
					{!store.instanceAnonymousUsers && <UserInfo />}
					<LanguageSelect />
					{/* For admin to quickly get back to admin panel */}
					{store.userHasAdminAccess && <GoAdminButton />}

					{(location.pathname == ROUTES.USER || location.pathname.includes("/form/")) && <UserSideActiveConfigNavigation />}
				</HyperDiv>
			</HyperDiv>
		</div>
	)
})

export default NavBarUserDesktop
